// для тех, кто отмечен как менеджер контрагента, для люксов
export const ENTITY_WITH_MANAGER_OR_OWNER = {
    LIST_COMPANY: true,
    LIST_ADDRESS_COMPANY: true,
    LIST_CONTACT_PERSONS: true,
    COMPANY_CRM: true,
    LIST_CONTRACTS: true,
    LIST_DOCUMENTS: true,
    CAPITAL_ACCOUNT:true,

    // LW-1457
    ORDER: true,
    OPERATION_UNIT: true,
    OPERATION: true,
    OPERATION_SEA: true,
    OPERATION_FORWARD: true,
    OPERATION_CUSTOMS: true,
    OPERATION_TRAIN: true,
    OPERATION_AUTO: true,
    OPERATION_AIR: true,
    OPERATION_SUB_DOC: true,
    OPERATION_DOCUMENTATION: true,
    OPERATION_REPACKING: true,
    OPERATION_OTHER: true,
    USER_TASK: true,

    // lw-9315
    OPERATION_SUB_DOC_AUTO: true,
    OPERATION_SUB_DOC_TRAIN: true,
    OPERATION_SUB_DOC_SEA: true,
    OPERATION_SUB_DOC_AIR: true,
    OPERATION_SUB_DOC_REPACKING: true,
    OPERATION_SUB_DOC_CUSTOMS: true,
    OPERATION_SUB_DOC_FORWARD: true
};

// без этого, лог операции в заказе не будут нормально работать
// или нельзя будет редактировать типы контрактов и тд
export const ENTITY_ANY_USER_CAN_EDIT = {
    LIST_TYPE_CONTRACTS: true,
    // @see FormRights
    _OPERATION_OTHER: true,
    OPERATION: true,
    DATA_CHANGES_LOG: true,
    DYNAMIC_JOURNAL_USER_LINK: true
};

// куча скрытых справочников, которых нет в меню прав
export const EXCLUDE_FROM_RIGHTS_FILTER = {
    PROBABILITY: true,
    STATUS_KP: true,
    NVOCC: true,
    SAP_GBR: true,
    COMPANY_ADDITIONAL_INFORMATION: true,
    CAPITAL_ACCOUNT_LIQUIDITY: true,
    CAPITAL_ACCOUNT_TYPE: true,
    BL_TYPE: true,
    TRANSPORTATION_TYPES: true,
    REASON_BEING_LATE: true,
    INVOICE_PROGRESS_STATUS: true,
    FINANCIAL_STATUS: true,
    CUSTOM_MODE: true,
    DYNAMIC_JOURNAL_COLUMNS: true,
    COMPANY_STORAGE_RATES: true,
    STORAGE_RATES: true,
    CALCULATION_TYPE: true,
    PAYMENT_ORDERS_OUR_COMPANY: true,
    CONSIGNEE_GTD_UNITS_REPORT: true,
    NOTY_TYPE: true,
    NOTY_CONTACT_SETTINGS: true,
    NOTY_USER_SETTINGS: true,
    USER_NOTY_TYPE: true,
    NOTY_USER_TEMPLATE: true,
    SETTINGS: true,
    COMPANY_CATEGORY_TYPE: true,
    MENU: true,
    NOTIFICATIONS: true,
    SYS_FILES: true,
    CHAT_ROOMS: true,
    CHAT_MESSAGES: true,
    DISCLAIMERS: true,
    //LIST_USER: true,
    SYS_CLIENT_OPTIONS: true,
    SYS_ACL_ROLE: true,
    LIST_TYPE_ROLE: true,
    LIST_WAREHOUSE_TYPE_ROLE: true,
    TRAIN_OPERATION_UNIT_LINK: true,
    EDI_STATUS_UNIT: true,

    TEMPLATE_INVOICE_POSITION: true,
    TEMPLATE_INVOICE: true,
    // LW-3916
    TEMPLATE_INVOICE_COMPANY_CONSIGNEE_LINK: true,

    OPERATION_CARGO_STATUS_EX_T1: true,
    COMMENTS: true,
    COMPANY_ADDITIONAL_OKVED: true,
    COMPANY_CLIENT_OR_OUR: true,
    COMPANY_COMPANY_LINK: true,
    COMPANY_EGRUL: true,
    COMPANY_FOUNDER: true,
    COMPANY_USER_LINK: true,
    CONTRACTS_FEA_VECTOR: true,
    CURRENT_USER_TASK: true,
    DATA_CHANGES_LOG: true,
    DECLARATION_UNIT: true,
    DEPARTMENT_COMPANY_LINK: true,
    DEPARTMENT_USER_LINK: true,
    DEPARTMENT_USER_LIST: true,
    DOCUMENT_MANAGEMENT_DOCS: true,
    DOCUMENT_MANAGEMENT_DOC_TYPE: true,
    DOCUMENT_MANAGEMENT_TYPE: true,
    DOCUMENT_STATUS: true,
    EGRUL_DOC: true,
    ERROR_TYPE: true,
    FIN_OPERATION_CASH_PAY_TYPE: true,
    FIN_OPERATION_MAIN_TYPE: true,
    FIN_OPERATION_TYPE: true,
    FIN_OPERATION_UNIT_LINK: true,
    FORWARD_OPERATION_DOC_TYPE: true,
    RENOMINATED_INVOICES: true,
    FSS: true,
    GTD_ADDITIONAL_CHECK_STATUS: true,
    GTD_ADDITIONAL_CHECK_TYPE: true,
    IFNS: true,
    INSTRUCTION_EXECUTOR_TYPE: true,
    INVOICE_NEED_OUTGOING_TYPE: true,
    INVOICE_POSITIONS: true,
    INVOICE_SET_SUM_TYPE: true,
    INVOICE_STATUS: true,
    INVOICE_TYPE: true,
    INVOICE_UNLOAD_TYPE: true,
    INVOICE_UNLOAD_1C_TYPE: true,
    LIST_CARGO: true,
    LIST_COMPANY_CLIENT: true,
    LIST_COMPANY_CONSIGNEE: true,
    LIST_COMPANY_CONSIGNOR: true,
    LIST_COMPANY_OUR: true,
    LIST_COMPANY_SUPPLIER: true,
    LIST_CONTACT_DATA: true,
    LIST_CONTACT_PERSONS_DATA: true,
    LIST_COUNTRY_DST: true,
    LIST_COUNTRY_SRC: true,
    LIST_CURRENCY: true,
    LIST_CURRENCY_BUY: true,
    LIST_CURRENCY_SALE: true,
    LIST_CURRENCY_WITHOUT_MULTI: true,
    LIST_ED: true,

    // вынесли в права
    //LIST_FEACC_GTD: true,

    LIST_FEACC_ARTICLE: true,
    LIST_FEACC_CONTAINERS: true,
    LIST_FEACC_DOCUMENTS: true,
    LIST_FEACC_GTD_TYPE_RISK: true,
    LIST_FEACC_GTD_UPDATING_KIND: true,
    LIST_FORM: true,
    LIST_GTD_OBJECT_ED_TYPE: true,
    LIST_PAYMENTS_GTD_LINK: true,
    LIST_REQUISITES: true,
    LIST_RESIDENT: true,
    LIST_RUR_EQUIV: true,
    LIST_TYPE_ACCOUNT: true,
    LIST_TYPE_COMPANY: true,
    LIST_TYPE_CONTACT: true,
    LIST_TYPE_FEACC_DOCUMENTS: true,
    LIST_TYPE_FLAT: true,
    LIST_TYPE_LINK: true,
    LIST_TYPE_ROLE2: true,
    LIST_TYPE_ROLE_COMPANY: true,
    LIST_TYPE_ROLE_COMPANY1: true,
    LIST_TYPE_UNIT: true,
    LIST_TYPE_VAT: true,
    LIST_TYPE_WEIGHT_UNIT: true,
    LIST_VAT_REQUEST: true,
    LIST_WAREHOUSES_COMPANY_LINK: true,
    LIST_WAREHOUSES_COMPANY_LINK_TYPE: true,
    LIST_WAREHOUSES_ROLES_LINK: true,
    LIST_WAREHOUSE_WAREHOUSES_LINK: true,
    LIST_WEIGHT_UNIT: true,
    OPERATION_ARRIVAL_POINT: true,
    OPERATION_ARRIVAL_POINT_TYPE: true,
    OPERATION_FORWARD_TYPE: true,
    OPERATION_GROUP_TYPE: true,
    OPERATION_NEED_SECURITY: true,
    OPERATION_RATE_EXPENSE: true,
    OPERATION_RATE_EXPENSE_INCLUDE: true,
    OPERATION_RATE_EXPENSE_INCLUDE_FIN_LINK: true,
    OPERATION_SCHEME: true,
    OPERATION_SEA_THC: true,
    OPERATION_SEA_TYPE: true,
    OPERATION_STATUS: true,
    OPERATION_SUB_DOC_TYPE: true,
    OPERATION_TYPE: true,
    OPERATION_UNIT_CATEGORY: true,
    OPERATION_UNIT_FILLED_TYPE: true,
    OPERATION_UNIT_LINK: true,
    OPERATION_UNIT_SCOPE: true,
    OPERATION_UNIT_STATUS: true,
    CHECK_CUSTOM_PAYMENTS: true,
    ORDER_ASSISTANT_LINK: true,
    ORDER_FOR_OWNER_UNIT: true,
    ORDER_FOR_OWN_ROLLING_STOCK_UNIT: true,
    ORDER_PAY_TYPE: true,
    ORDER_REQUEST_NOTY_USERS: true,
    ORDER_STATUS: true,
    ORDER_STATUS_ZTM: true,
    ORDER_TYPE: true,
    ORDER_USER_LINK_OPERATIONAL: true,
    ORDER_USER_LINK_SALES: true,
    ORDER_REQUEST_CURRENCY_TRANSLATION: true,
    PAYMENTS_GTD_TYPE: true,
    PAYMENT_ORDERS_INVOICES: true,
    PAYMENT_ORDERS_PK: true,
    PF: true,
    QUARANTINE_CERTIFICATE: true,
    REMEMBER: true,
    REMEMBER_TYPE: true,
    REQUEST_STATUS: true,
    SEA_LINE_DAYS: true,
    SYSTEM_USER_LINK: true,
    SYS_ACL_ROLE_USER: true,
    TEMPLATES: true,
    TEMPLATE_DATA: true,
    TRANSIT_TIME_TYPE: true,
    USER_ADDITIONAL_CREDENTIALS: true,
    USER_ADDITIONAL_CREDENTIALS_TYPE: true,
    USER_TASK_IMPORTANCE: true,
    USER_TASK_LOG: true,
    USER_TASK_STATUS: true,
    USER_TASK_TEMPLATE_LINK: true,
    USER_TASK_THEME_USER_TYPE: true,
    USER_TASK_TYPE: true,
    USER_TASK_WATCHER_LINK: true,
    USER_TASK_THEME_WATCHER_LINK: true,

    CRM_REQUEST_SOURCE: true,
    GU_FORM_STATUS: true,
    LIST_INSPECTOR: true,
    LIST_COMPANY_MARKS: true,
    LIST_COMPANY_LIFE_CYCLE: true,
    CONTRACTS_ADDITION_TYPE: true,
    GTD_MODE: true,
    REQUEST_CURRENCY_TRANSLATION_TYPE: true,
    CONTRACTS_MATH_DETAILS: true,
    CONTRACTS_PAYMENT_TYPE: true,
    CONTRACTS_STATUS: true,
    CONTRACTS_RELATION_TYPE: true,
    PRODUCTION: true,
    COMPANY_CRM_STATUS: true,
    COMPANY_CRM_TYPE_REQUEST: true,
    COMPANY_CRM_EVENT_IMPORTANT: true,
    COMPANY_CRM_EVENT_CONNECTION_TYPE: true,
    CRM_ASSISTANT_LINK: true,
    OPERATION_PACKING_UNIT_TYPE: true,
    OPERATION_FORWARD_INSPECTION_TYPE: true,
    DOC_OPERATION: true,
    DOC_OPERATION_TYPE: true,
    DOC_OPERATION_UNIT_LINK: true,
    ORDER_REQUEST_CONTRACT_TYPE: true,
    WORK_INSTRUCTIONS_TYPE: true,
    WORK_INSTRUCTIONS_STATUS: true,
    ADDITIONAL_CONTROL_TYPE: true,
    LIST_ADDRESS_COMPANY: true,
    LIST_COMPANY_BANKS: true,
    LIST_COMPANY_BANK_ACCOUNTS: true,
    LIST_TYPE_CONTRACTS: true,
    COMPANY_GTD_BALANCE: true,
    SUBDIVISION: true,

    CRM_REQUEST_STATUS: true,
    FIN_SETTINGS: true,

    // позиции инвойсов, ставим пока видимость всем
    PART_NUMBER_POSITION: true,

    TP_ELS: true,
    TP_ELS_UNKNOWNS: true,

    BUSINESS_PROCESS_OBJECT_TYPE: true,
    OPERATION_CUSTOM_STATUS: true,
    PAYMENT_ORDERS_TRANSFERS: true,
    PAYMENT_ORDERS: true,

    // LIST_WAREHOUSE: true,
    USER_TASK_THEME_TO_BUS_OP: true,

    FEEDBACK_TYPE: true,
    // 4709
    FIN_OPERATION_BY_UNIT: true,
    FIN_OPERATION_BY_OWNER_UNIT: true,

    FIN_OPERATION_BY_OWN_ROLLING_STOCK_UNIT: true,
    CRITERIA_VALUE: true,
    LIST_USER_WITH_COMPANY_LINK: true,
    USER_ROLE: true,
    OPERATION_UNIT_TYPE: true,
    CHECK_CUSTOM_PAYMENTS_NOTE: true,
    // lw-6802 этот справочник используется на форме контрагентов
    // и чтобы получилось просмотреть файл по ссылке нужны права на него
    LIST_CONTRACTS_BY_COMPANY: true,

    // lw-6914
    // для возможности редактирования шаблонов уведомлений неадминам
    NOTY_CONTACT_TEMPLATE: true,
    TNVED_PACKING_UNIT_TYPE: true,

    // lw-7211
    // для возможности изменения на форме договора
    DEFERRED_PAYMENT_TYPES: true,
    DELAY_DAYS_TYPES: true,

    USER_LANG: true,
    GROUPING_COLUMNS: true,
    GTD_INVOICE_POSITION: true,

    ORDER_KIND: true,

    PAYMENT_ORDERS_SWIFT_TYPE: true,

    OPERATION_RAILWAY_TRANSPORT_SIGN: true,
    AGREED_STATUS: true,

    // lw-6333
    // что бы мочь видеть какие балнки вообще можно получить и кому
    REPORT_SETTINGS_SYS_ACL_ROLE_LINK: true,
    REPORT_OUR_COMPANYS: true,

    COMPANY_CONTACT_PERSONS_LINK: true,

    DEC_UNIT_OPER_UNIT_LINK: true,
    CONTRACTS_CLOSING_TYPE: true,

    FIN_OPERATION_SET_SUM_TYPE: true,
    DOC_UNIT_LINK: true,

    // lw-9841
    MANAGER_BONUS_POSITIONS: true,
    MANAGER_BONUS_SETTINGS: true,

    CAPITAL_OPERATION: true,
    CAPITAL_ACCOUNT_SALDO: true,

    PAYMENT_DAY_OF_THE_WEEK: true,
    PAYMENT_DAY_OF_THE_MONTH: true,
    LINK_LIST_CONTRACTS_PAYMENT_DAY_OF_THE_MONTH: true,
    CRITERIA_DELAY: true,
    SERVICE_COMBINATION_RATE_EXPENSE_CATEGORY: true
};

// LW-383
// Лобачева: Заполнение полей Декларант и Формализатор должно происходить по принципу,
// как это сделано в старой логистике
// (сотрудники отдела декларирования могут проставить данное значение,
// но изменить внесённое значение может только Лобачева)
export const EMPTY_EXCLUSIVE = {
    Canavara: {
        OPERATION_UNIT: ["ID_USER_FORMALIZER", "ID_USER_UNIT_GTD"],
        // LW-1532
        ORDER: [
            "IS_COMPLETE_RATES", "IS_LOGIST_RATES", "IS_LOGIST_EXPORT_RATES",
            "IS_VALID_RATES", "INSTRUCTION", "FORWARDING_RECEIPT", "WAREHOUSE_RECEIPT"
        ],
        INVOICE_OUTGOING: ["IS_CLOSING_DOCUMENTS_ISSUE"]
    },
    KTS:{
        ORDER: [
            "IS_LOGIST_RATES", "IS_LOGIST_EXPORT_RATES"
        ]
    },
    Eastex: {
        ORDER: ["ACTUAL_DATE_LOGIST_COMPLETE","MARGIN_DEPOSITED"]
    },
    Spiko: {
        INVOICE_OUTGOING: ["ID_INVOICE_1C_UNLOAD_TYPE"],
        INVOICE_INCOMING: ["ID_INVOICE_1C_UNLOAD_TYPE"]
    },
    All: {
        ORDER: ["ACTUAL_DATE_COMING"],
        excludeModules: ["DelExpress"]
    }
};

// В картчоке юзера есть поле Контрагент, следующие сущности фильтруем по айдишнику этого контрагента
// В KEY_BY_ENTITY_NAME ключи - это сущности, а значения - столбцы по которым будем фильтровать
export const KEY_BY_ENTITY_NAME = {
    ORDER: {
        comma: "ORDER_COMPANY_CLIENT_PARTNER_COMMA"
    },
    OPERATION_UNIT: {
        comma: "ORDER_COMPANY_CLIENT_PARTNER_COMMA"
    },
    LIST_ALL_GTD: {
        comma: "COMPANY_CLIENT_BROKER_COMMA"
    },
    LIST_ACTIVE_GTD: {
        comma: "COMPANY_CLIENT_BROKER_COMMA"
    },
    LIST_ARCHIVE_GTD: {
        comma: "COMPANY_CLIENT_BROKER_COMMA"
    },
    OPERATION_SUB_DOC: {
        executor: "COMPANY_EXECUTOR_NAME",
        comma: "COMPANY_PARTNER_CLIENT_COMMA"
    },
    OPERATION_SUB_DOC_AUTO: {
        executor: "COMPANY_EXECUTOR_NAME",
        comma: "COMPANY_PARTNER_CLIENT_COMMA"
    },
    OPERATION_SUB_DOC_TRAIN: {
        executor: "COMPANY_EXECUTOR_NAME",
        comma: "COMPANY_PARTNER_CLIENT_COMMA"
    },
    OPERATION_SUB_DOC_SEA: {
        executor: "COMPANY_EXECUTOR_NAME",
        comma: "COMPANY_PARTNER_CLIENT_COMMA"
    },
    OPERATION_SUB_DOC_AIR: {
        executor: "COMPANY_EXECUTOR_NAME",
        comma: "COMPANY_PARTNER_CLIENT_COMMA"
    },
    OPERATION_SUB_DOC_REPACKING: {
        executor: "COMPANY_EXECUTOR_NAME",
        comma: "COMPANY_PARTNER_CLIENT_COMMA"
    },
    OPERATION_SUB_DOC_CUSTOMS: {
        executor: "COMPANY_EXECUTOR_NAME",
        comma: "COMPANY_PARTNER_CLIENT_COMMA"
    },
    OPERATION_SUB_DOC_FORWARD: {
        executor: "COMPANY_EXECUTOR_NAME",
        comma: "COMPANY_PARTNER_CLIENT_COMMA"
    },
    ALTA_CBX_DATA: {
        anyRole: true,
        equal: "PAYER_ID"
    }
};

export const OPERATION_SUB_DOC_REGEXP = new RegExp(
    "^OPERATION_SUB_DOC(_(AUTO|TRAIN|SEA|AIR|REPACKING|CUSTOMS|FORWARD))?$"
);
